<div class="ws-popup-header">
  <div class="title">
    <div class="title-ref">{{ "Gift Redeem" | translate }}</div>
  </div>
</div>

<div class="content-wrapper">
  <div *ngIf="previewLoading" class="field-wrapper first-row">
    <div class="message-text">{{ 'Loading redemption details…' | translate }}</div>
  </div>

  <div *ngIf="!previewLoading && previewUnavailable" class="field-wrapper first-row">
    <div class="info-message">{{ 'Gift redemption preview unavailable.' | translate }}</div>
  </div>

  <div *ngIf="!previewLoading && preview?.anomalies?.length" class="redemption-preview-warnings">
    <div class="warning-title">{{ 'Attention: experience changes detected' | translate }}</div>
    <ul>
      <li *ngFor="let a of preview.anomalies">{{ anomalyText(a) }}</li>
    </ul>
    <div class="warning-footer">
      {{ 'Proceeding will redeem the gift regardless of the detected changes.' | translate }}
    </div>
  </div>

  <div *ngIf="!showRedeemInput" class="field-wrapper first-row">
    <div class="message-text">
      {{ "Force redeem of this gift or open gift link?" | translate }}
    </div>
  </div>

  <div *ngIf="showRedeemInput" class="field-wrapper first-row">
    <label for="reservation-id"><i class="icon-calendar"></i>
      {{ "Associate reservation (optional)" | translate }}
    </label>
    <div class="field-wrapper">
      <input type="text"
             matInput
             id="reservation-id"
             [(ngModel)]="reservationId"
             placeholder="{{ 'Enter reservation ID' | translate }}"/>
    </div>

    <div class="info-message">
      <i class="icon-info"></i>
      {{ "If empty, no reservation will be associated to the gift and there will be no creation date for the gift." | translate }}<br>
      {{ "Manual reservations cannot be associated." | translate }}
    </div>
  </div>
</div>

<div *ngIf="!showRedeemInput" class="button-lower-row dws-elevation-z2">
  <ws-button [callToActionType]="'danger'" (click)="closeClicked()">
    {{ "Close" | translate }}
  </ws-button>

  <div class="save">
    <ws-button [callToActionType]="'tertiary'" (click)="onLinkClick()">
      {{ "Link" | translate }}
    </ws-button>
    <ws-button [callToActionType]="'primary'" (click)="onRedeemClick()">
      {{ "Redeem" | translate }}
    </ws-button>
  </div>
</div>

<div *ngIf="showRedeemInput" class="button-lower-row dws-elevation-z2">
  <ws-button [callToActionType]="'tertiary'" (click)="onCancelRedeem()">
    {{ "Back" | translate }}
  </ws-button>

  <ws-button [callToActionType]="'primary'"
             [disabled]="isLoadingRedeem"
             (click)="onConfirmRedeem()">
    {{ "Redeem" | translate }}
  </ws-button>
</div>